import React from 'react'
import PageHeader from '../components/PageHeader'

function Clients() {
    const logos = [1, 2, 3, 4, 5, 6, 7, 8, 9]

    return (
        <>
            <PageHeader title="Our clients" />

            <div className="page-client">
                <div className="container">
                    <div className="row">
                        {logos.map((num, idx) => (
                            <div className="col-lg-4 col-md-4 col-6" key={idx}>
                                <div
                                    className="company-logo wow fadeInUp"
                                    data-wow-delay={`${idx * 0.2}s`}
                                >
                                    <img
                                        src={`${process.env.PUBLIC_URL}/images/company-logo-${num}.svg`}
                                        alt=""
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    )
}

export default Clients
